import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import translationBackend from 'i18next-xhr-backend'
import languageDetector from 'i18next-browser-languagedetector'

import en from './en/translation.json'
import pt from './pt/translation.json'
import es from './es/translation.json'

const lng = localStorage.getItem('language')
const fallbackLng = 'en'
const availableLanguages = ['en', 'pt', 'es']

/**
 * @todo
 * enum Languages {En = 'en',Es = 'es',Pt = 'pt'}
 * olhar as variações languageDetector pt -> pt-BR, pt-br, pt_br?
 */

i18n
  .use(initReactI18next) // pass the i18n instance to react-i18next.
  .use(languageDetector) // detect user language
  .use(translationBackend) // load translation using xhr -> see /public/locales. We will add locales in the next step
  .init({
    lng,
    fallbackLng, // default
    debug: process.env.REACT_APP_ENV !== 'production',
    load: 'languageOnly',

    supportedLngs: availableLanguages,
    resources: {
      en: { translation: en },
      es: { translation: es },
      pt: { translation: pt }
    },

    interpolation: {
      escapeValue: false
    },

    detection: {
      order: ['localStorage', 'navigator'],
      caches: [],
      lookupLocalStorage: 'i18next'
    }
  })

export default i18n
